import classNames from 'classnames';
import * as React from 'react';
import { UiProvider } from 'providers/UiProvider';
import s from './Cycles.scss';

interface GridCellProps {
  onClick(): void;
  disabled: boolean;
  bordered?: boolean;
  shadowed?: boolean;
  padded?: 'Right' | 'Left';
  dataHook: string;
  className?: string[];
}

export const GridCell: React.FunctionComponent<GridCellProps> = ({
  children,
  padded,
  onClick,
  disabled,
  bordered,
  dataHook,
  className,
}) => {
  const handleClick = () => (disabled ? null : onClick());
  return (
    <UiProvider>
      {({ themeName }) => (
        <div
          className={classNames(
            s.cellWrapper,
            {
              [s.bordered]: bordered,
              [s.disabled]: disabled,
            },
            className,
            themeName,
          )}
          style={{ [`padding${padded}`]: '30px' }}
          onClick={handleClick}
          data-hook={dataHook}
        >
          {children}
        </div>
      )}
    </UiProvider>
  );
};
